import { render } from "./BacklogView.vue?vue&type=template&id=6c72d764&scoped=true"
import script from "./BacklogView.vue?vue&type=script&lang=js"
export * from "./BacklogView.vue?vue&type=script&lang=js"

import "./BacklogView.vue?vue&type=style&index=0&id=6c72d764&scoped=true&lang=css"

import exportComponent from "/github/workspace/src/mealplanner-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c72d764"]])

export default __exports__